import base from '../httpApi/base'; // 导入接口域名列表
import axios from '../httpApi/http'; // 导入http中创建的axios实例
const report = {
    //后台
    //获取检举内容
    GetReportData(params) {
        return axios.get(`${base.dev}/services/app/AdminReport/GetAll`, { params })
    },
    //修改检举状态
    UpdateStatus(params) {
        return axios.put(`${base.dev}/services/app/AdminReport/UpdateStatus
        `, params);
    },
}
export default report


// WEBPACK FOOTER //
// ./src/api/report/report.js